(function($, undefined) {
	
	'use strict';
    var addRowBtn;
    var addColBtn;
    var delColBtn;
    var delRowBtn;

    var save = function(key,val,lang,callback,reset){
        var ap = actionPath || "/action/";
        
        ajax(ap + "addSiteLabel?lang=" + lang + "&key=" + key +
                "&value=" + (reset ? '' : encodeURIComponent(val)), callback, true);
    };
    
    var addRow = function(){
        var table = $(this).closest(".custom-table");
        var id = table.attr("data-id");
        var key = table.attr("data-labelR");
        var rows = table.attr("data-rows");
        
        var btn = table.find(".add-more-row-btn");
        var btn2 = table.find(".add-more-col-btn");
        
        var tr = document.createElement("tr");
        var newRow = parseInt(rows) + 1;
        table.find("tr:last td").each(function() {
            var i = $(this).attr("data-col");
            var td = document.createElement("td");
            td.setAttribute("data-row", rows);
            td.setAttribute("data-col", i);
            if($(this).find(".del-row-btn").length != 0){
                $(this).find(".del-row-btn").clone(true).appendTo($(td));
            }
            var span = document.createElement("span");
            span.innerHTML = "Double-cliquez-ici !";

            $(span).on("dblclick", null, {index: i, item: span}, function(e) {
                modifyLabel('component.table.td.' + rows + '.' + e.data.index + '.' + id, e.data.item, '5000', 'fr');
            });
            td.append(span);
            tr.append(td);
            table.attr("data-rows", newRow);
        });
        save(key, newRow, "fr", function() {
            table.append(tr);
            btn.appendTo(table.find("tr:last td"));
            btn2.appendTo(table.find("tr td:last"));
        });
        
    };
    
    var addCol = function(){
        var table = $(this).closest(".custom-table");
        var id = table.attr("data-id");
        var key = table.attr("data-labelC");
        var rows = table.attr("data-rows");
        var cols = table.attr("data-cols");
        
        var btn = table.find(".add-more-row-btn").clone(true);
        var btn2 = table.find(".add-more-col-btn").clone(true);
        
        var newCol = parseInt(cols) + 1;
        if (table.find("tr:eq(0) td").length < 7) {
            save(key, newCol, "fr", function() {
                table.find("tr").each(function() {
                    var i = $(this).attr("data-row");
                    var td = document.createElement("td");
                    td.setAttribute("data-row", i);
                    td.setAttribute("data-col", cols);
                    btn.appendTo($(td));
                    btn2.clone(true).appendTo($(td));
                    if($(this).find(".del-col-btn").length !== 0){
                        $(this).find(".del-col-btn").clone(true).appendTo($(td));
                    }
                    var span = document.createElement("span");
                    span.innerHTML = "Double-cliquez-ici !";
                    $(span).on("dblclick", null, {index: i, item: span}, function(e) {
                        modifyLabel('component.table.td.' + e.data.index + '.' + cols + '.' + id, e.data.item, '5000', 'fr');
                    });
                    td.append(span);
                    $(this).append(td);
                    table.attr("data-cols", newCol);
                });
//                btn.appendTo(table.find("tr:last td:last"));
            });
        }
//        else{            
//            btn.appendTo(table.find("tr:last td"));
//            btn2.appendTo(table.find("tr td:last"));
//        }
    };
    
    var delCol = function(){
        var table = $(this).closest("table");
        var key = table.attr("data-labelCD");
        var del = table.attr("data-colsD");
        var elmt = $(this).closest("td");
        var pos = elmt.attr("data-col");
        
            
        if (table.find("tr:eq(0) td").length > 1) {
            save(key, del + "-" + pos, "fr", function() {
                table.attr("data-colsD", del + "-" + pos);
                table.find("td[data-col = " + pos + "]").remove();
            });
        }
        
    };
    
    var delRow = function(){
        var table = $(this).closest("table");
        var key = table.attr("data-labelRD");
        var del = table.attr("data-rowsD");
        var elmt = $(this).closest("tr");
        var pos = elmt.attr("data-row");
        
        
        if (table.find("tr").length > 1) {
            save(key, del + "-" + pos, "fr", function() {
                table.attr("data-rowsD", del + "-" + pos);
                table.find("tr[data-row = " + pos + "]").remove();
            });
        }
    };
    
    var addLine = function(elmt){
        elmt.each(function(){
            var link = $(this).find(".component-image-text").next().find("a");
            if (link.length !== 0) {
                link.find(".line").remove();
                if ($(this).find(".component-image-switch").length !== 0) {
                    link.wrap("<div class='link-wrapper link-wrapper-left'></div>");
                    link.append($("<span class='line left'/>"));
                }
                else {
                    link.wrap("<div class='link-wrapper'></div>");
                    link.append($("<span class='line'/>"));
                }
            }
        });
    };
    
//    var saveClick = function(){
//        lastClickBtn = $(this);
//    }
    
	var init = function () {
        
        addRowBtn = $(".add-more-row-btn");
        addColBtn = $(".add-more-col-btn");        
        addRowBtn.on("click", addRow);
        addColBtn.on("click", addCol);
        
        delRowBtn = $(".del-row-btn");
        delColBtn = $(".del-col-btn");        
        delRowBtn.on("click", delRow);
        delColBtn.on("click", delCol);
        
//        $(".picker-btn-block").on("click", saveClick);
//        $(".temp-img-holder").on("change", saveBlock);
           
	};
	
	$(window).on('load', function () {
		init();
	});
	
})(jQuery);
